import { service } from '@ember/service'
import type { IntlService } from 'ember-intl'
import { RolloverStep } from 'teacher-ui-client/school-rollover/steps'
import StepRoute from 'teacher-ui-client/manage/rollover/steps/step-route'

export default class StudentsRoute extends StepRoute {
  @service intl!: IntlService

  /**
   * @property stepId used by {StepRoute} to save the furthest step visited.
   */
  stepId = RolloverStep.Students

  buildRouteInfoMetadata() {
    let title = this.intl.t('manage.rollover.title')
    if (this.intl.exists(`manage.rollover.steps.${this.stepId}.title`)) {
      title = this.intl.t(`manage.rollover.steps.${this.stepId}.title`)
    }
    return { stepId: this.stepId, title }
  }
}
